export let images = {
    svg: [],
}

//svg
images.svg['cherry-1'] = require('../static/img/svg/cherry1.svg')
images.svg['cherry-2'] = require('../static/img/svg/cherry2.svg')
images.svg['cherry-3'] = require('../static/img/svg/cherry3.svg')
images.svg['cherry-4'] = require('../static/img/svg/cherry4.svg')

images.svg['grid'] = require('../static/img/svg/grid.svg')
images.svg['grid-numbers'] = require('../static/img/svg/grid_numbers.svg')
images.svg['grid-cell'] = require('../static/img/svg/grid_cell.svg')

images.svg['two-directional-boxes'] = require('../static/img/svg/two_directional_boxes.svg')
images.svg['two-directional-boxes-2'] = require('../static/img/svg/two_directional_boxes_2.svg')

images.svg['number-line'] = require('../static/img/svg/number_line.svg')
images.svg['number-line-axis'] = require('../static/img/svg/number_line_axis.svg')
images.svg['number-line-bg-red'] = require('../static/img/svg/number_line_bg_red.svg')
images.svg['number-line-bg-green'] = require('../static/img/svg/number_line_bg_green.svg')
images.svg['plus'] = require('../static/img/svg/plus.svg')
images.svg['minus'] = require('../static/img/svg/minus.svg')
images.svg['multiply'] = require('../static/img/svg/multiply.svg')
images.svg['devide'] = require('../static/img/svg/devide.svg')
images.svg['equal'] = require('../static/img/svg/equal.svg')
images.svg['answer'] = require('../static/img/svg/answer.svg')





// WEBPACK FOOTER //
// ./src/services/assets.services.js